module.exports = __webpack_public_path__ + "fonts/Typo_Round_Bold_Italic_Demo.65b661ef.otf";